var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgOsUnix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.437 1.007h2.937v.471q0 4.137.002 8.275c0 .236 0 .477.042.708.299 1.67 1.596 2.419 3.422 1.984 1.22-.291 1.783-1.1 1.785-2.597.005-2.796.001-5.592.001-8.388V1h2.97v.412c0 2.796.014 5.593-.01 8.388a7.8 7.8 0 0 1-.245 1.885c-.374 1.43-1.312 2.405-2.732 2.88a8.06 8.06 0 0 1-4.862.114c-2.082-.596-3.27-2.022-3.312-4.148-.062-3.131-.022-6.265-.026-9.398 0-.036.015-.072.028-.126",
    clipRule: "evenodd"
  })));
});